import { notFound } from '@tanstack/react-router';

import { getPage } from '@/lib/content-registry';
import { seoHead } from '@/lib/seo';
import { ContentBlock } from '@/blocks/control-content';

export function contentRouteOptions(path: string) {
  return {
    loader: () => {
      if (!getPage(path)) throw notFound();
      return { path };
    },
    head: () => seoHead(getPage(path)!),
    component: () => <ContentBlock page={getPage(path)!} />,
  };
}
